<h2 mat-dialog-title>
    {{ data.email.subject }}
</h2>

<mat-dialog-content>
    <div *ngIf="href">
        <iframe [src]="safeUrl" style="width: 100%; height: 500px; border: 0;"></iframe>
    </div>
</mat-dialog-content>